import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

import { useAuthState } from 'react-firebase-hooks/auth';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase.init';
import {
    faBarsStaggered,
    faAngleDown,
    faSignOut
} from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';
import { Card, Container, Nav, Navbar, NavDropdown, Offcanvas } from 'react-bootstrap';
import './Header.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const [show, setShow] = useState(false);
    const [user, loading] = useAuthState(auth);
    const [showDropdown, setShowDropdown] = useState(false);
    const location = useLocation();

    const handleToggle = () => setShow(true);
    const handleClose = () => setShow(false);

    const logout = (e) => {
        e.preventDefault();
        signOut(auth);
        toast.info('Signing Out...', {
            toastId: 'Signing',
            className: 'red-toast',
            icon: <FontAwesomeIcon icon={faRightFromBracket} bounce size="sm" style={{ color: "red" }} />,
            progressClassName: 'red-progress-bar',
        });
    };



    return (
        <div>
            {/* <div className="container" data-aos="fade-down" data-aos-anchor-placement="center-bottom">
                <Navbar collapseOnSelect expand="lg" bg="transparent" className="custom-navbar">
                    <Container style={{ height: '50px' }}>


                        <Navbar.Collapse id="responsive-navbar-nav" className="d-none d-lg-block">
                            <Nav className="mx-auto navLinks text-start">

                            </Nav>
                            {user ? (
                                <Nav className='text-start'>
                                    <NavDropdown
                                        title={
                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                {user.email.split("@")[0]} <FontAwesomeIcon icon={faAngleDown} />
                                            </span>
                                        }
                                        id="collasible-nav-dropdown"
                                        alignRight
                                    >
                                        <Card style={{ border: '1px solid rgb(177, 17, 17)', borderRadius: '8px' }}>
                                            <Card.Body style={{ padding: '10px', backgroundColor: '#f8d7da' }}>
                                                <NavDropdown.Item
                                                    href="#"
                                                    onClick={logout}
                                                    style={{
                                                        color: 'rgb(177, 17, 17)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '10px',
                                                        borderRadius: '5px',
                                                        transition: 'background-color 0.3s',
                                                    }}
                                                    className="logout-item"
                                                >
                                                    <FontAwesomeIcon icon={faSignOut} style={{ marginRight: '8px' }} />
                                                    Log out
                                                </NavDropdown.Item>
                                            </Card.Body>
                                        </Card>
                                    </NavDropdown>
                                </Nav>
                            ) : (
                                <Nav.Link style={{ cursor: 'pointer', color: 'red', fontWeight: 'bold' }} href="/login">Sign in</Nav.Link>

                            )}
                        </Navbar.Collapse>
                    </Container>
                </Navbar>

            </div> */}
        </div >
    );
};

export default Header;